module.exports = __webpack_public_path__ + "017e728a0bc4c65f96e123f5b1b14cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_blue.png
// module id = 19
// module chunks = 0 1 2 3